import { SvgIcon, SvgIconProps } from '@mui/material';

const ShopeeIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="translate(2, 0)">
          <path d="M9.99985 0.399902C7.869 0.399902 6.2415 2.38116 6.06626 4.7999H2.02329C1.56929 4.7999 1.1996 5.1923 1.22485 5.64521L1.9147 17.714C1.97449 18.7688 2.85462 19.5999 3.91079 19.5999H16.0889C17.1454 19.5999 18.0252 18.7686 18.085 17.714L18.7749 5.646C18.8009 5.19276 18.4304 4.7999 17.9764 4.7999H13.9334C13.7582 2.38116 12.1307 0.399902 9.99985 0.399902ZM9.99985 1.1999C11.6146 1.1999 12.9634 2.75462 13.1342 4.7999H6.86548C7.03628 2.75462 8.38508 1.1999 9.99985 1.1999ZM10.0319 7.1999C11.5679 7.1999 12.7195 8.02428 12.8155 8.08428L12.4038 8.75225C12.3038 8.68425 12.1241 8.57584 12.0561 8.53584C11.6481 8.31584 10.8959 7.98818 10.0319 7.98818C8.73188 7.98818 7.79204 8.7079 7.79204 9.6999C7.79204 10.6879 8.66395 11.0798 10.0959 11.6038C11.5479 12.1318 13.1881 12.7317 13.1881 14.6397C13.1881 16.0757 11.7719 17.2038 9.96392 17.2038C8.36792 17.2038 7.05588 16.224 6.73188 15.964L7.17563 15.3038C7.18763 15.3158 8.46392 16.4116 9.96392 16.4116C11.3079 16.4116 12.3999 15.6157 12.3999 14.6397C12.3999 13.3757 11.4281 12.9277 9.82407 12.3437C8.50407 11.8597 7.00376 11.3119 7.00376 9.6999C7.00376 8.2759 8.30388 7.1999 10.0319 7.1999Z" />
        </g>
      </svg>
    </SvgIcon>
  );
};

export default ShopeeIcon;
